//订单状态
export const ORDER_STATUS = new Map([
    [1, '已结清'],
    [3, '赊欠'],
    [11, '退款'],
    [13, '作废'],
]);
